import UserManager from "./manager/UserManager";

const SupplierService = {
  url: `${process.env.VUE_APP_API_URL}suppliers`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  canSelectVendor: async () => {
    try {
      const supplier = UserManager.get();

      return !!supplier.can_select_vendor;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  getCustomers: async (data = {}) => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      // Build query parameters for sorting and filtering
      const params = new URLSearchParams();

      // Set orderBy for alphabetical sorting (default)
      params.append("orderBy", data.orderBy || "name");
      params.append("orderDirection", data.orderDirection || "asc");

      // Add user_id filter if provided
      if (data.user_id) {
        params.append("user_id", data.user_id);
      }

      // Add any other filters from data object
      for (const key in data) {
        if (
          key !== "orderBy" &&
          key !== "orderDirection" &&
          key !== "user_id"
        ) {
          params.append(key, data[key]);
        }
      }

      // Use URLSearchParams for GET request rather than body
      const response = await fetch(
        `${SupplierService.url}/get-customers?${params.toString()}`,
        {
          method: "GET",
          headers: SupplierService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  getVendors: async () => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${SupplierService.url}/get-vendors`, {
        method: "GET",
        headers: SupplierService.headers,
      });

      const data = await response.json();

      return data?.data;
    } catch (error) {
      console.error(error);

      return false;
    }
  },

  getBusinessInformation: async (id = null) => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(
        `${SupplierService.url}/get-business-information${
          id ? "?id=" + id : ""
        }`,
        {
          method: "GET",
          headers: SupplierService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  getSuppliersToShow: async (data) => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const params = new URLSearchParams(data);

      const response = await fetch(
        `${SupplierService.url}/get-suppliers-to-show?${params}`,
        {
          method: "GET",
          headers: SupplierService.headers,
        }
      );

      return response;
    } catch (e) {
      return [];
    }
  },
  getBankAccountsBySupplier: async (supplier_id) => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(
        `${SupplierService.url}/get-bank-accounts/${supplier_id}`,
        {
          method: "GET",
          headers: SupplierService.headers,
        }
      );

      return response;
    } catch (e) {
      return [];
    }
  },

  getAccountStatus: async () => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${SupplierService.url}/account-status`, {
        method: "GET",
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  exportAccountStatus: async () => {
    try {
      const headers = SupplierService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(
        `${SupplierService.url}/export-account-status`,
        {
          method: "GET",
          headers: headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default SupplierService;
